import { render, staticRenderFns } from "./IndustryInformation.vue?vue&type=template&id=2d40da63&scoped=true&"
import script from "./IndustryInformation.vue?vue&type=script&lang=js&"
export * from "./IndustryInformation.vue?vue&type=script&lang=js&"
import style0 from "./IndustryInformation.vue?vue&type=style&index=0&id=2d40da63&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40da63",
  null
  
)

export default component.exports